require('./about.less');

var appFunc = require('../utils/appFunc');

module.exports = {
    init: function(){
        appFunc.hideToolbar();
    }
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/modules/about/about.js
 ** module id = 39
 ** module chunks = 0
 **/